var _style, _g, _pattern, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.7 120.9",
    style: {
      enableBackground: "new 0 0 113.7 120.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FC8DE4;}\n\t.st2{fill:#F9A7E9;}\n\t.st3{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:url(#);}\n\t.st5{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("pattern", {
    x: 375.2,
    y: -454.7,
    width: 497,
    height: 342.9,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern_7",
    viewBox: "58.2 -514.3 497 342.9",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.2,
    y: -514.3,
    className: "st0",
    width: 497,
    height: 342.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.3-258.8c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C518.7-293.9,460.9-248.3,442.3-258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497-192.6c6.2,23.4,17.7,55.3,40.5,87.8C585.5-36.4,651.9-9.4,679.5,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0-192.6c6.2,23.4,17.7,55.3,40.5,87.8C88.4-36.4,154.8-9.4,182.5,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497-535.4c6.2,23.4,17.7,55.3,40.5,87.8c47.9,68.3,114.3,95.3,141.9,104.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.8-430.2c-16-9-18.3-67.7,14.3-81.2c20.4-8.4,49.4,2.9,54.2,19.1C270.2-465.3,212.4-419.8,193.8-430.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.5-364c6.2,23.4,17.7,55.3,40.5,87.8c47.9,68.3,114.3,95.3,141.9,104.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0-535.4c6.2,23.4,17.7,55.3,40.5,87.8c47.9,68.3,114.3,95.3,141.9,104.7"
  }))))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#New_Pattern_7",
    patternTransform: "matrix(0.1929 0 0 0.205 -6582.4404 -6055.5454)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    width: 113.7,
    height: 120.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern3);
export default __webpack_public_path__ + "static/media/Pattern3.ee97a76729931bfd1c775347d3699137.svg";
export { ForwardRef as ReactComponent };